import Spark from 'app/assets/icons/SmartDocs/Spark.svg'
import { Box, Button, Flex } from 'app/components/design-system-components'
import theme from 'app/match/applicationReportPDF/assets/theme'
import { NEXT_GEN_LEASING_URL } from 'app/utils/text/helpers'

function CopilotTextLogo({ withLearnMore = false, copilotSuggestions = 0 }) {
  return (
    <Flex
      justifyContent="space-between"
      width="100%"
      alignItems="end"
      fontWeight="700"
      mb={4}
    >
      <Flex alignItems="end">
        <Box fontSize="22px" fontWeight="700">
          Copilot
        </Box>
        <Box mb={3}>
          <img
            src={Spark}
            alt="Copilot Icon"
            width={theme.width[6] + 'px'}
            height={theme.height[6] + 'px'}
          />
        </Box>
        {withLearnMore && (
          <Box>
            <Button
              sizeVariant="extraSmall"
              variant="linkBlueWithoutWeight"
              onClick={() => {
                window.open(NEXT_GEN_LEASING_URL, '_blank')
              }}
              ml={5}
              fontWeight="400"
            >
              learn more
            </Button>
          </Box>
        )}
      </Flex>
      <Box ml={4} fontSize="14px" fontWeight="500">
        {copilotSuggestions} suggestions
      </Box>
    </Flex>
  )
}

export default CopilotTextLogo
